































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { CourseItem } from '@/common/interface';
import GroupActivitySection from '@/components/groupType/index/GroupActivitySection.vue';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import DashLine from '@/components/common/edit/DashLine.vue';
import { resolveBoundaryValue } from '@/common/utils/format';
import { Tip } from '@/common/interface';
import Tips from '@/components/common/index/Tips.vue';
import { majorNoticeText } from '@/common/constants/index';
import GroupLadder from '@/pages/groupType/components/edit/GroupLadder.vue';
import getUrlParam from '@/common/utils/getUrlParam';
import { Ladder } from '@/common/interface/group_type';
import ImageCutUpload from '@/components/common/edit/ImageCutUpload.vue';
import CourseImage from './CourseImage.vue';
import CourseName from './CourseName.vue';
import CourseDesc from './CourseDesc.vue';
import CourseGroupDesc from './CourseGroupDesc.vue';
const confirmContent = `<p>您当前设置为“拼团价”支付模式，若需添加多阶拼团方案，请改为“定金”支付模式</p>`;
const ladderGroupTips = {
  title: '拼团方案',
  content: ` <p>1、拼团模式最多可设置5组价格梯度，成团人数越多，则对应拼团价越低</p>
          <p>2、多阶拼团模式下，若需开启支付功能，则仅支持“定金”支付，不支持“拼团价”支付</p>`
};

@Component({
  components: {
    'group-activity-section': GroupActivitySection,
    'course-name': CourseName,
    'course-image': CourseImage,
    'course-desc': CourseDesc,
    'course-group-desc': CourseGroupDesc,
    'activity-label': ActivityLabel,
    'dash-line': DashLine,
    'group-ladder': GroupLadder,
    'image-cut-upload': ImageCutUpload,
    tips: Tips
  }
})
export default class GroupActivityRule extends Vue {
  @Getter('section') section: any;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: string;
  @Getter('xcxType') xcxType!: string;
  @Getter('canPay') canPay!: boolean;
  @Getter('payType') payType!: string;
  @Getter('ladderGroupList') ladderGroupList!: Ladder[];
  @Getter('courseGroupList') courseGroupList!: any;

  @Action('changeSectionInfo') changeSectionInfo!: Function;
  @Action('changePayType') changePayType!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;
  @Action('changeCourseGroupLadder') changeCourseGroupLadder!: Function;
  @Action('changeCourseGroupOriginPrice') changeCourseGroupOriginPrice!: Function;
  @Action('changeSectionCourseType') changeSectionCourseType!: Function;

  ladderGroupTips: Tip = ladderGroupTips;
  exampleVisible: boolean = false;
  

  get courseType(): string {
    return this.section.courseType;
  }
  get courseName(): string {
    return this.section.courseName;
  }
  get disabled() {
    return getUrlParam('type') === 'reEdit';
  }
  handleDisabled(type:string) {
    if (type === 'new'||!this.disabled) {
      return false
    } 
    return true
  }
  // 修改奖品信息
  changeCourseInfo(event: Event, type: string) {
    const payload = {
      value: (event.target as HTMLInputElement).value,
      type
    };
    this.changeSectionInfo(payload);
  }

  // 选择课程类型
  selectCourse(type: string) {
    if (this.disabled) {
      Vue.$toast.error('发布活动后不可修改课程模式');
      return;
    }
    this.changeSectionCourseType(type);
  }

  handleInputBlur(value: number, type: string, decimal: boolean = false, seqNo: Number = 1, index: number = 0, list: any = []) {
    const _value = resolveBoundaryValue(value, decimal);
    if (type === 'originPrice') {
      const payload = {
        value: _value,
        seqNo
      };
      this.changeCourseGroupOriginPrice(payload);
    }
    if (['groupSize', 'groupPrice'].includes(type)) {
      let _list = JSON.parse(JSON.stringify(list));
      _list[index][type] = _value;
      const payload = {
        value: _list,
        seqNo
      };
      this.changeCourseGroupLadder(payload);
    }
  }

  // 删除拼团方案
  handleDeleteLadder(list: any, seqNo: Number, index: number) {
    let _list = JSON.parse(JSON.stringify(list));
    _list.splice(index, 1);
    const payload = {
      value: _list,
      seqNo
    };
    this.changeCourseGroupLadder(payload);
  }

  handleAddLadder(list: any, seqNo: Number) {
    if (this.xcxType === 'mkb') {
      return;
    }
    // 普通用户不支持
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    // 判断是否开启了“拼团价”模式
    if (this.canPay && this.payType === '拼团价') {
      Vue.$confirm({
        okText: '定金支付',
        classname: 'text-align-left',
        text: confirmContent,
        ok: () => {
          this.changePayType({ payType: '定金' });
          let _list = JSON.parse(JSON.stringify(list));
          // 新增一个拼团方案
          _list.push({
            groupSize: '',
            groupPrice: ''
          });
          const payload = {
            value: _list,
            seqNo
          };
          this.changeCourseGroupLadder(payload);
        }
      });
    } else {
      let _list = JSON.parse(JSON.stringify(list));
      // 新增一个拼团方案
      _list.push({
        groupSize: '',
        groupPrice: ''
      });
      const payload = {
        value: _list,
        seqNo
      };
      this.changeCourseGroupLadder(payload);
    }
  }
  // 添加新课程
  addCourseItem() {
    let len = this.courseGroupList.length;
    let _courseGroupList = JSON.parse(JSON.stringify(this.courseGroupList));
    let item = JSON.parse(JSON.stringify(_courseGroupList[len - 1]));
    item.seqNo = item.seqNo + 1;
    if (this.disabled) {
      item.type = 'new';
    }
    _courseGroupList.push(item);
    const payload = {
      value: _courseGroupList,
      type: 'courseGroupList'
    };
    this.changeSectionInfo(payload);
  }
  // 删除新课程
  deleteCourse(seqNo: number) {
    let _courseGroupList = JSON.parse(JSON.stringify(this.courseGroupList));
    _courseGroupList.splice(seqNo - 1, 1);
    for (let i = 0; i < _courseGroupList.length; i++) {
      _courseGroupList[i].seqNo = i + 1;
    }
    const payload = {
      value: _courseGroupList,
      type: 'courseGroupList'
    };
    this.changeSectionInfo(payload);
  }
  handleExampleModal() {
    this.exampleVisible = !this.exampleVisible;
    this.changeShowFooter(!this.exampleVisible);
  }

  // 上传图片
  handleChangeCourseImage(imgUrl: string, index: number) {
    console.log(imgUrl, index);
    let _courseGroupList = JSON.parse(JSON.stringify(this.courseGroupList));
    _courseGroupList[index].courseCover = imgUrl;
    const payload = {
      value: _courseGroupList,
      type: 'courseGroupList'
    };
    this.changeSectionInfo(payload);
  }
  getNumberStr(seqNo: number) {
    const arr = ['一', '二', '三', '四', '五', '六']
    return arr[seqNo - 1];
  }
}
